import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import ProductCard from './ProductCard';
import { IconChevronLeft, IconChevronRight } from '../common/Icons';

// Responsive product carousel (grid on desktop, swipe on mobile) as used by the homepage product tabs.
export default function ProductSlider({ products = [], columns = 6, id = 'ps' }) {
  if (!products.length) return <p className="text-center text-color-secondary py-10">No products found.</p>;
  const cols = Math.min(columns, products.length);
  return (
    <div className="sf__ms sf__ms--slider relative">
      <Swiper
        modules={[Navigation, Pagination]}
        navigation={{ prevEl: `.${id}-prev`, nextEl: `.${id}-next` }}
        pagination={{ el: `.${id}-pag`, clickable: true }}
        spaceBetween={30}
        breakpoints={{
          0: { slidesPerView: 2, spaceBetween: 10 },
          640: { slidesPerView: 2, spaceBetween: 20 },
          768: { slidesPerView: Math.min(3, cols), spaceBetween: 30 },
          1024: { slidesPerView: Math.min(4, cols), spaceBetween: 30 },
          1280: { slidesPerView: cols, spaceBetween: 30 },
        }}
        className="sf-grid sf__ms-wrapper swiper-container swiper-container-initialized"
      >
        {products.map((p) => (
          <SwiperSlide key={p._id} className="sf-column">
            <ProductCard product={p} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="sf-slider__controls flex items-center justify-center mt-5 md:mt-0 -mx-2 sf-slider__controls--absolute" style={{ '--nav-offset': '25px', '--offset-top': '40%' }}>
        <button type="button" className={`sf-slider__controls-button swiper-button-prev sf-slider__controls-prev border rounded-full hidden md:inline-flex ${id}-prev`} aria-label="Previous"><IconChevronLeft width={16} height={16} /></button>
        <div className={`swiper-pagination w-full sm:mt-6 flex md:hidden ${id}-pag`} />
        <button type="button" className={`sf-slider__controls-button swiper-button-next sf-slider__controls-next border rounded-full hidden md:inline-flex ${id}-next`} aria-label="Next"><IconChevronRight width={16} height={16} /></button>
      </div>
    </div>
  );
}
